export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals-portals/modal-i24.store.ts"